export default __webpack_public_path__ + "static/media/hht2_ep18_timeline_q02_a.cc6d13d5.png";